import React from "react";
import "../../../stylesheet/components/catalogue/dropdown/SortByDropdown.scss";
import { useTranslation } from "react-i18next";

type SortByDropdownProps = {
  setOrderBy: (newOrderBy: string) => void;
  toggleSortByDropdown: () => void;
};

const SortByDropdown: React.FC<SortByDropdownProps> = ({
  setOrderBy,
  toggleSortByDropdown,
}) => {
  const { t } = useTranslation();

  const handleMostRecentOnClick = () => {
    setOrderBy("desc");
    toggleSortByDropdown();
  };

  const handleOldestOnClick = () => {
    setOrderBy("asc");
    toggleSortByDropdown();
  };

  return (
    <div className="sort-dropdown-items">
      <div className="sort-item" onClick={handleMostRecentOnClick}>
        <div className="p2">{t("catalogue-filter.most-recent")}</div>
      </div>
      <div className="sort-item" onClick={handleOldestOnClick}>
        <div className="p2">{t("catalogue-filter.oldest")}</div>
      </div>
    </div>
  );
};

export default SortByDropdown;
